import { InputMask } from '@react-input/mask'
import { forwardRef, ReactNode } from 'react'

import { montserrat } from '@/app/fonts'
import { SquircleAdapter } from '../SquircleAdapter'

import './styles.scss'

export type InputProps = {
  label?: string
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  containerStyle?: React.CSSProperties
  wrapperStyle?: React.CSSProperties
  mask?: 'zipCode' | 'phone'
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      name,
      leftIcon,
      rightIcon,
      containerStyle,
      wrapperStyle,
      mask,
      ...rest
    },
    ref,
  ) => {
    const MASK_MAP = {
      zipCode: {
        mask: '_____-___',
        replacement: { _: /\d/ },
      },
      phone: {
        mask: '(__) _____-____',
        replacement: { _: /\d/ },
      },
    }

    const maskConfig = mask ? MASK_MAP[mask] : undefined

    const labelFor = rest.id ?? name

    return (
      <div className="input-container" style={wrapperStyle}>
        {!!label && <label htmlFor={labelFor}>{label}</label>}

        <SquircleAdapter
          cornerRadius={16}
          className="input-container__wrapper"
          style={containerStyle}
        >
          {leftIcon && leftIcon}

          {mask ? (
            <InputMask
              {...rest}
              id={labelFor}
              value={rest.value}
              mask={maskConfig?.mask}
              replacement={maskConfig?.replacement}
              onChange={rest.onChange}
              placeholder={rest.placeholder}
              ref={ref}
              autoComplete={rest.autoComplete ?? 'off'}
            />
          ) : (
            <input
              {...rest}
              style={montserrat.style}
              ref={ref}
              autoComplete={rest.autoComplete ?? 'off'}
            />
          )}
          {rightIcon && rightIcon}
        </SquircleAdapter>
      </div>
    )
  },
)

Input.displayName = 'Input'
